<script setup lang="ts">
  import { modals, removeModal } from '@/stores/modal';
  const viewport=ref<Record<string,string>>({});
  const lockTarget=ref<HTMLElement|null>(null),scrollLocked=useScrollLock(lockTarget);
  function updateViewport(){const v=window.visualViewport;viewport.value={'--uo-modal-visible-height':`${v?.height??window.innerHeight}px`,height:`${v?.height??window.innerHeight}px`,top:`${v?.offsetTop??0}px`};}
  onMounted(()=>{lockTarget.value=document.body;updateViewport();window.visualViewport?.addEventListener('resize',updateViewport);window.visualViewport?.addEventListener('scroll',updateViewport);window.addEventListener('resize',updateViewport);});
  watch(()=>modals.value.length,n=>{scrollLocked.value=n>0},{immediate:true});
  watch(lockTarget,()=>{scrollLocked.value=modals.value.length>0});
  onBeforeUnmount(()=>{scrollLocked.value=false;window.visualViewport?.removeEventListener('resize',updateViewport);window.visualViewport?.removeEventListener('scroll',updateViewport);window.removeEventListener('resize',updateViewport);});
</script>

<template>
 <Teleport to="body">
  <div class="uo-modal-layer fixed inset-0 grid place-items-center sm:p-4 bg-black/l z-40 overflow-hidden"
    :style="viewport"
    v-if="modals.length"
    
    @click.self="removeModal"
  >
    <!-- FXME исправить передачу класа ?? -->
    <Suspense>
      <div
        v-for="({ component, componentProps, events, title, body, actions, class:cls }, index) in modals"
        :key="index" role="dialog" aria-modal="true" :aria-labelledby="title?'uo-modal-title-'+index:undefined" :aria-label="title?undefined:'Форма'"
        :class="`uo-modal-panel animate-slide-up min-h-min p-4 sm:p-8 row-start-1 col-start-1 w-full max-w-[calc(100vw-2rem)] bg-slate-50 flex flex-col gap-4 sm:rounded-2xl shadow-xl overflow-hidden relative ${cls ?? 'max-w-screen-xs'}`"
      >
        <h3 :id="'uo-modal-title-'+index" class="m-0 text-2xl" v-if="title">{{ title }}</h3>
        <button type="button" class="uo-modal-close uo-icon-btn" aria-label="Закрыть окно" @click="removeModal"><Icon name="mdi:close" size="24" /></button>
        <component
          v-if="component"
          v-bind:is="component"
          v-on="{ ...events }"
          v-bind="{ ...componentProps }"
          @modal:remove="removeModal"
        ></component>
        <div v-else v-html="body" v-on="{ ...events }"></div>
        <div class="uo-modal-actions" v-if="actions?.length">
          <!--
            TODO: 
              1. Кнопки могут быть заблокированны и менятся от условий (вроде можно сделать через глобальный body:has(form[name="demo"]) button[form="demo"])
              2. Кнопка может быть с типом reset (передавать много параметрова через v-bind )
              3. Возможно нужно сразу описать стандартное поведение при submit, reset хотя оно может изменится
          -->
          <CommonButton :class="className" v-for="({ className, title, action, form, type, to }, i) in actions" :key="i" @click="() => action && (action() || removeModal())" :form="form" :type="type" :to="to">
            {{ title }}
          </CommonButton>
        </div>
      </div>
      <template #fallback>
        <div class="text-white">
          <svg class="animate-spin h-12 w-12 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      </template>
    </Suspense>
  </div>
 </Teleport>
</template>
